import { Divider, Dropdown, Grid, Selector } from "antd-mobile";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { HomeCard } from "../../../../../components";
import { moneyFormat } from "../../../../../plugins/numberFormat";
import { useComission } from "../../context/ComissionContext";
import styles from "./style.module.scss";
import "./style.scss";
const ComissionData = () => {
  const { t } = useTranslation();
  const {
    months,
    selectedMonth,
    setSelectedMonth,
    weeks,
    selectedWeek,
    setSelectedWeek,
    comissionHeader,
    isHeaderError,
    isHeaderLoading,
  } = useComission();
  const dropDownRef = useRef();

  const onSelectMonthChange = (value) => {
    if (value.length > 0) {
      const _month = months.find((month) => month.value === value[0]);
      setSelectedMonth(_month);
      dropDownRef.current.close();
    }
  };

  const onSelectWeekChange = (value) => {
    if (value.length > 0) {
      const _week = weeks.find((week) => week.value === value[0]);
      console.log("_week", _week);
      setSelectedWeek(_week);
      dropDownRef.current.close();
    }
  };

  const comissionList = [
    {
      title: t("comission.calculation.winloss"),
      valueKey: "calculated_loss_amount",
      type: "content",
      symbol: "+",
    },
    {
      title: t("comission.calculation.platform"),
      valueKey: "total_game_3th_fee",
      type: "content",
      symbol: "-",
    },
    // {
    //   title: t("comission.calculation.promotion"),
    //   valueKey: "total_promotion_rebate_fee",
    //   type: "content",
    //   symbol: "-",
    // },
    {
      title: t("comission.calculation.comission"),
      valueKey: "basic_bonus_amount",
      type: "footer",
      symbol: "+",
    },
  ];

  return (
    <div className={`${styles.container} comission-container`}>
      <Dropdown ref={dropDownRef}>
        {/* <Dropdown.Item key={"month"} className={"custom-dropdown"} title={selectedMonth?.label}>
          <div className={`filter-select`}>
            <Selector
              className={"custom-selector"}
              options={months}
              columns={2}
              value={selectedMonth?.value}
              onChange={onSelectMonthChange}
            />
          </div>
        </Dropdown.Item> */}
        <Dropdown.Item key={"week"} className={"custom-dropdown"} title={selectedWeek?.label}>
          <div className={`comission-report-filter-select`}>
            <Selector
              className={"custom-selector"}
              options={weeks}
              columns={2}
              value={selectedWeek?.value}
              onChange={onSelectWeekChange}
            />
          </div>
        </Dropdown.Item>
      </Dropdown>
      {isHeaderLoading ? (
        ""
      ) : isHeaderError ? (
        ""
      ) : (
        <>
          <HomeCard title={t("comission.calculation.comission")}>
            {comissionList.map((comission, index) => {
              return (
                <>
                  <div
                    className={`${styles.listRow} ${
                      comission.type === "footer" ? styles.footer : ""
                    }`}
                  >
                    <div className={styles.title}>{comission.title}</div>
                    <div className={styles.content}>
                      {`${
                        comission.symbol === "-" && comissionHeader?.data[comission.valueKey] > 0
                          ? "-"
                          : ""
                      } ${moneyFormat(comissionHeader?.data[comission.valueKey])}`}
                    </div>
                  </div>
                  {index < comissionList.length - 1 ? <Divider className={styles.divider} /> : null}
                </>
              );
            })}
          </HomeCard>

          {/* <HomeCard title={t("comission.calculation.levelBonusTotal")}>
            {Object.keys(comissionHeader?.data?.agent_level_bonus).map((key, index) => {
              const _level = key.split("-")[1];
              return (
                <>
                  <div className={`${styles.listRow}`}>
                    <div className={styles.title}>
                      {t("mobile.comission.calculation.levelBonus", {
                        level: _level,
                      })}
                    </div>
                    <div className={styles.content}>
                      {`${moneyFormat(
                        comissionHeader?.data?.agent_level_bonus[key].level_bonus_amount,
                      )}`}
                    </div>
                  </div>
                  {index < Object.keys(comissionHeader?.data?.agent_level_bonus).length - 1 ? (
                    <Divider className={styles.divider} />
                  ) : null}
                </>
              );
            })}
            <div className={`${styles.listRow} ${styles.footer}`}>
              <div className={styles.title}>{t("comission.calculation.levelBonusTotal")}</div>
              <div className={styles.content}>
                {moneyFormat(comissionHeader.data.level_bonus_total_amount)}
              </div>
            </div>
          </HomeCard> */}
        </>
      )}
      <HomeCard title={t("administrationCenter.overview.commision.title.new")}>
        <Grid columns={2} gap={0}>
          <Grid.Item>
            <div className={styles.menu}>
              <div className={styles.overviewTitle}>
                <div className={styles.title}>{t(`mobile.comission.ratio.winloss`)}</div>
              </div>
              <div className={styles.overviewContent}>{`${
                comissionHeader?.data?.win_loss_bonus_rate || 0
              }%`}</div>
            </div>
          </Grid.Item>
          {/* <Grid.Item>
            <div className={styles.menu}>
              <div className={styles.overviewTitle}>
                <div className={styles.title}>{t(`mobile.comission.ratio.activeMember`)}</div>
              </div>
              <div className={styles.overviewContent}>{`${
                comissionHeader?.data?.eligible_user_rate || 0
              }%`}</div>
            </div>
          </Grid.Item> */}
          <Grid.Item>
            <div className={styles.menu}>
              <div className={styles.overviewTitle}>
                <div className={styles.title}>{t(`mobile.comission.ratio.agentBonus`)}</div>
              </div>
              <div className={styles.overviewContent}>{`${
                comissionHeader?.data?.add_agent_bonus_rate || 0
              }%`}</div>
            </div>
          </Grid.Item>
          {/* {levelBonusRate
            ? levelBonusRate?.map((level) => {
                return (
                  <Grid.Item>
                    <div className={styles.menu}>
                      <div className={styles.overviewTitle}>
                        <div className={styles.title}>
                          {t("mobile.comission.ratio.levelBonus", {
                            level: level.level,
                          })}
                        </div>
                      </div>
                      <div className={styles.overviewContent}>{`${level.bonus_rate || 0}%`}</div>
                    </div>
                  </Grid.Item>
                );
              })
            : null} */}
        </Grid>
      </HomeCard>
    </div>
  );
};

export default ComissionData;
